<template>
  <mc-modal
    :heading="$t('common.delete')"
    :open="showConfirmationModal"
    data-test="delete-filter-modal"
    @closed="closeDeleteConfirmation"
  >
    <div>
      {{ $t("filter.deleteConfirmation") }}
      <b> {{ filterName }} </b>
    </div>
    <mc-notification v-if="showDeleteFilterError" type="error" icon="error">
      <span v-text="$t('filter.error.deleteFail')" />
    </mc-notification>
    <mc-button
      slot="primaryAction"
      :label="$t('common.confirm')"
      appearance="primary"
      @click="deleteSelectedFilter(index)"
    />
    <mc-button
      slot="secondaryAction"
      appearance="neutral"
      :label="$t('common.cancel')"
      @click="closeDeleteConfirmation"
    />
  </mc-modal>
</template>
<script>
import { mapActions, mapState } from "pinia";
import { filters } from "@/store/filters";
import emitter from "tiny-emitter/instance";
import { getExportImportPage } from "@/lib/utilities";

export default {
  name: "DeleteFilter",
  props: {
    index: {
      type: Number,
      required: true,
      default: -1
    },
    filterName: {
      type: String,
      required: true,
      default: ""
    }
  },
  data() {
    return {
      showConfirmationModal: false
    };
  },

  computed: {
    ...mapState(filters, ["showDeleteFilterError"])
  },
  mounted() {
    emitter.on("delete-filter-modal", this.toggleConfirmationModal);
  },
  methods: {
    ...mapActions(filters, ["deleteFilter", "updateDeleteFilterError"]),
    closeDeleteConfirmation() {
      this.updateDeleteFilterError(false);
      this.showConfirmationModal = false;
    },
    toggleConfirmationModal() {
      this.updateDeleteFilterError(false);
      this.showConfirmationModal = !this.showConfirmationModal;
    },
    deleteSelectedFilter(index) {
      this.deleteFilter(index);
      this.showConfirmationModal = false;
      this.$sendGAEvent({
        event: "DQCS",
        action: "Click",
        category: "Component",
        label: { data: `${getExportImportPage()} Shipment filter delete` }
      });
    }
  }
};
</script>
